import { GROUP_ACCOUNT_TYPES } from '../constants';
import { CurrentUser, User, UserType } from '../types/user';

function getGroupFromUser(currentUser: CurrentUser, { id, type }: { id: string; type: string }) {
  if (!currentUser || !id || !type) return undefined;

  if (type === GROUP_ACCOUNT_TYPES.BUSINESS) {
    return (currentUser.businesses || []).find((group) => group._id === id);
  }
  if (type === GROUP_ACCOUNT_TYPES.FAMILY) {
    return (currentUser.families || []).find((group) => group._id === id);
  }
  return undefined;
}

const formatName = (appUser: User) => {
  if (!appUser) {
    return '...';
  }
  const lastName = appUser?.lastName || '';
  const firstName = appUser?.firstName || '';
  return firstName || lastName || '...';
};

const formatFullName = (user: { firstName?: string; lastName?: string }) => {
  if (!user) {
    // console.warn('appUser not found');
    return '...';
  }
  //console.warn('full',nameOption, appUser.lastName, appUser.firstName);
  let fullname = '';

  const lastName = user?.lastName || '';
  const firstName = user?.firstName || '';
  fullname = `${firstName} ${lastName}`;

  if (fullname.trim()) {
    return fullname.trim();
  }
  //else
  //    console.warn("appUser name empty", appUser);

  return '...';
};

function isAdmin(user?: User) {
  return user?.type === UserType.SystemAdmin;
}

export const UserHelper = {
  getGroupFromUser,
  formatName,
  formatFullName,
  isAdmin,
};
